module.exports = __webpack_public_path__ + "static/media/ball.580ae522.png";